import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useMatch, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Spinner } from "../components/BootstrapCompo";
import loginSuccess from "../context/actions/auth/loginSuccess";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import validations from "../utils/validations";
import ShadowzLogo from "../assets/images/ShadowzLogo.svg";

export default ({ logOutNow }) => {
  const navigate = useNavigate();
  const { authDispatch } = useContext(GlobalContext);
  const match = useMatch("/reset-password")
  const [password, setPassword] = useState()
  const [confirmPassword, setConfirmPassword] = useState()
  const location = useLocation();
  const newParam = new URLSearchParams(location.search)
  const [passwordFirstEye, setPasswordFirstEye] = useState(false);
  const [confirmPasswordFirstEye, setConfirmPasswordFirstEye] = useState(false);
  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false)
  const [againReset, setAgainReset] = useState(true)
  const [passwordValidation, setPasswordValidation] = useState(false)

  const [state, setState] = useState({
    password: "",
    Confirm_password: "",
  });


  const handlePassword = (e) => {
    setPassword(e)
    if (!confirmPassword) {
      return setPasswordValidation(false)
    }
    // if(!e) return setPasswordValidation(true)
    if (e == confirmPassword) {
      return setPasswordValidation(false)
    }
    // if(e!=confirmPassword){
    //   return  setPasswordValidation(true)
    //   }
    if (e != "") {
      return setPasswordValidation(true)
    }
    else setPasswordValidation(false)
  }

  const handleConfirmPassword = (e) => {
    setConfirmPassword(e)
    console.log(e, "=", confirmPassword);
    if (!password) {
      return setPasswordValidation(false)
    }
    if (!e) return setPasswordValidation(false)

    if (e != password) {
      return setPasswordValidation(true)
    }
    else setPasswordValidation(false)
  }

  // const { password, Confirm_password } = state;
  const onSubmitForm = () => {
    if (!validations.strongPasswordValidation(password)) {
      return toast.warn("Password must contain characters, Numbers and special characters")

    }
    if (state.password !== state.Confirm_password) {
      toast.warn("Password & Confirm Password not same")
    } else {
      setState({
        ...state,
        // loading: true,
      });
      let items = {
        unique_code: newParam.get("unique_code"),
        password: password,
        // Confirm_password: Confirm_password,
        language: "ENGLISH",
      };
      try {
        setLoading(true)
        henceforthApi.Auth.resetPassword(items)
          .then((res) => {
            toast.success(res.message);
            setLoading(false)
            setShow(true)
            setConfirmPassword("")
            setPassword("")
            loginSuccess(res.data)(authDispatch);

            setTimeout(() => {
              navigate("/login");
            }, 1000);
            
          })
          .catch((err) => {
            let response = err.response.body;
            let error = response ? response.error_description : "Server error";
            // toast.error(error);
            setConfirmPassword("")
            setPassword("")
            setAgainReset(false)
            setLoading(false)
            if (error.error) {
              if (String(error.error).includes("unauthorized")) {
                logOutNow();
              } else {
                setState({
                  ...state,
                  // loading: false,
                });
              }
            } else {
              setState({
                ...state,
                // loading: false,
              });
            }
          });
      } catch (error) {
        setLoading(false)
      }
    }
  };

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <div className="Login">
        <div class="middle-box text-center loginscreen animated fadeInDown d-flex justify-content-center align-items-center">
          {
            show ?
              <div className='login-inner-box'>
                <div className="text-center">
                  {/* <h1 class="logo-name mt-5 mb-3 ">Shadowz</h1> */}
                  <img
                    className="logo-img"
                    height={50}
                    src={ShadowzLogo}
                  // style={{ marginBottom: "10px" }}
                  />
                  <h2 style={{ color: "#000" }}>Reset your Password</h2>
                </div>

                <div className="reset-password text-start border border-success px-4 py-3 bg-light mb-4 mt-4 rounded">
                  <h6 className="fw-semibold mb-1">Hooray !</h6>
                  <p className="m-0 text-nowrap">Your password has been Successfully changed</p>
                </div>


                {/* <div className="border border-3 border-success px-4 py-3 bg-light mt-4 rounded"> Password reset Successfully</div> */}
              </div> :

              <div className="w-100">
                <div className="m-auto py-3">

                  <img
                    className="logo-img m-0"
                    height={50}
                    src={ShadowzLogo}
                  />
                </div>
                <h2 style={{ color: "#000" }}>Reset your Password</h2>
                <form
                  class="m-t"
                  role="form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    onSubmitForm();
                  }}
                >
                  {
                    againReset ? "" : <div className="reset-password text-start border border-danger px-4 py-2 bg-light mb-4 rounded">
                      <h6 className="fw-semibold">Oh snap !</h6>
                      <p className="m-0 text-nowrap">Something went wrong, please try again.</p>
                    </div>
                  }
                  <div class="form-group">
                    <input
                      type={passwordFirstEye ? "text" : "password"}
                      className="form-control loginInput"
                      placeholder="Enter Password"
                      name="password"
                      value={password}
                      onChange={(e) => { handlePassword(e.target.value); console.log(e.target.value); }}
                      required
                    />
                    <i className={`fas  eye-btn ${passwordFirstEye ? `fa-eye` : `fa-eye-slash`}`}
                      onClick={() => setPasswordFirstEye(!passwordFirstEye)}
                      aria-hidden="true"
                    ></i>
                  </div>
                  <div class="form-group">
                    <input
                      type={confirmPasswordFirstEye ? "text" : "password"}
                      className={`form-control loginInput ${passwordValidation ? "invalid" : ""}`}
                      placeholder="Confirm Password"
                      name="Confirm_password"
                      value={confirmPassword}
                      onChange={(e) => { console.log(e.target.value); handleConfirmPassword(e.target.value) }}
                      required
                    />
                    <i
                      class={`fas  eye-btn ${confirmPasswordFirstEye ? `fa-eye` : `fa-eye-slash`
                        }`}
                      onClick={() =>
                        setConfirmPasswordFirstEye(!confirmPasswordFirstEye)
                      }
                      aria-hidden="true"
                    ></i>
                    {
                      passwordValidation ? <p style={{ color: "red" }} className="validation_font text-start">Password does not match the Confirm password</p> : ""
                    }
                  </div>
                  <button
                    style={{
                      backgroundColor: "#000",
                    }}
                    type="submit"
                    class="btn btn-primary block full-width m-b"
                    disabled={
                      loading || !password || !confirmPassword
                    }
                  >
                    {loading ? <Spinner /> : "Reset Password"}
                  </button>
                </form>
              </div>
          }
        </div>
      </div>
    </div>
  );
};
